import { ScheduleType } from '~/domain/PermanentJobs/enums/ScheduleType';

/**
 * Available benefits options for job postings
 */
export const benefitsOptions = [
  { code: 'Vision Insurance', name: 'Vision Insurance' },
  { code: 'Paid time off', name: 'Paid time off' },
  { code: 'Sign-On Bonus', name: 'Sign-On Bonus' },
  { code: 'Health Insurance', name: 'Health Insurance' },
  { code: 'Flexible Schedule', name: 'Flexible Schedule' },
  { code: 'Dental Insurance', name: 'Dental Insurance' },
  { code: '401(k)', name: '401(k)' },
  { code: 'Other', name: 'Other' },
];

/**
 * Schedule type options for job postings
 */
export const scheduleTypeOptions = [
  { code: ScheduleType.FULL_TIME, name: 'Full Time' },
  { code: ScheduleType.PART_TIME, name: 'Part Time' },
  { code: ScheduleType.FLEXIBLE, name: 'Flexible' },
];

/**
 * Expected days options for job postings
 * Code represents day of week (0 = Sunday, 1 = Monday, etc.)
 */
export const expectedDaysOptions = [
  { code: 1, name: 'Monday' },
  { code: 2, name: 'Tuesday' },
  { code: 3, name: 'Wednesday' },
  { code: 4, name: 'Thursday' },
  { code: 5, name: 'Friday' },
  { code: 6, name: 'Saturday' },
  { code: 0, name: 'Sunday' },
];

/**
 * Maximum length for job title
 */
export const jobTitleMaxLength = 50;

/**
 * Minimum length for job description
 */
export const jobDescriptionMinLength = 150;

/**
 * Maximum length for benefits other field
 */
export const benefitsOtherMaxLength = 100;

/**
 * Defines the mutation modes for handling `WorkingInterview` data updates.
 *
 * This enum specifies how incoming `WorkingInterview` data should be merged
 * or added to the existing state, allowing for different mutation strategies.
 *
 * - `Append`: Adds new `WorkingInterview` entries to the existing list without
 *   modifying current data.
 * - `Create`: Replaces or initializes the `WorkingInterview` data entirely
 *   with the new incoming data.
 */
export enum WorkingInterviewMutationMode {
  Append = 'APPEND',
  Create = 'CREATE',
}

export enum CandidateStatus {
  Hired = 'hired',
  Interviewed = 'interviewed',
  New = 'new',
  Rejected = 'rejected',
  Scheduled = 'scheduled',
}

export enum WorkingInterviewStatus {
  ActionNeeded = 'action_needed',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Open = 'open',
  Scheduled = 'scheduled',
}
